import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchDailyVehiclesSales = (filters) => {
  return apiActionCreator({
    'endpoint': `/vehicles/daily-vehicles-sales-and-stock${getUrlParameters(filters)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_DAILY_VEHICLES_SALES,
      ActionTypes.FETCHED_DAILY_VEHICLES_SALES,
      [
        ActionTypes.FETCHED_DAILY_VEHICLES_SALES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const downloadDailyVehiclesSales = (filters) => {
  const clientId = filters.clientId ? `&clientId=${filters.clientId}` : '';
  const agency = filters.agency ? `&agency=${filters.agency}` : '';
  const startDate = filters.startDate ? `&startDate=${filters.startDate}` : '';
  const endDate = filters.endDate ? `&endDate=${filters.endDate}` : '';

  const allFilters = `${clientId}${agency}${startDate}${endDate}`;

  return apiActionCreator({
    'endpoint': `/vehicles/daily-vehicles-sales-and-stock/excel?${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOADING_DAILY_VEHICLES_SALES,
      ActionTypes.DOWNLOADED_DAILY_VEHICLES_SALES,
      [
        ActionTypes.DOWNLOADED_DAILY_VEHICLES_SALES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchWalkIn = (filters) => {
  const dealerId = filters.clientId ? filters.clientId : 'ALL';

  return apiActionCreator({
    'endpoint': `/vehicles/walkin/initialDate/${filters.startDate}/finalDate/${filters.endDate}/dealerId/${dealerId}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_WALK_IN,
      ActionTypes.FETCHED_WALK_IN,
      [
        ActionTypes.FETCHED_WALK_IN_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};
